import React from "react";
import { Visual } from "../../shared/Visual";
import { AssetRendererProps } from "../RTF";

export const VideoRenderer: React.FC<AssetRendererProps> = (props) => {
  const videoRef = props.references
    ? (props.references[0] as Queries.VideoFragment)
    : undefined;
  if (videoRef) {
    return (
      <Visual visual={videoRef} className={props.classNameOverrides?.video} />
    );
  } else {
    console.log("Cannot attain video information");
    return null;
  }
};
